import { render, staticRenderFns } from "./OrganisationOverview.vue?vue&type=template&id=002f1a44&scoped=true"
import script from "./OrganisationOverview.vue?vue&type=script&lang=js"
export * from "./OrganisationOverview.vue?vue&type=script&lang=js"
import style0 from "./OrganisationOverview.vue?vue&type=style&index=0&id=002f1a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f1a44",
  null
  
)

export default component.exports